export default __webpack_public_path__ + "static/media/Asia_06.b285c79d.png";